import type { RecenzjaMowca } from "@shared/recenzjeTypy.js";
import { kluczMowcyRecenzji, type PowtarzaneSlowaWgMowcy } from "../../lib/powtarzaneSlowa.js";
import { ListaPowtarzanychSlow, OBJASNIENIE_POWTARZANYCH_SLOW, type PokazWypowiedzZeSlowem } from "../ocena/PowtarzaneSlowa.js";
import { Card } from "../ui/Card.js";

/**
 * "Powtarzane slowa" w linku recenzenta: to samo co sekcja w karcie oceny administratora, tylko do odczytu i dla kazdego
 * mowcy po kolei (recenzent nie ma przelacznika mowcy). Liczy przegladarka z wypowiedzi, ktore recenzent juz dostal
 * (lib/powtarzaneSlowa.ts), wiec zadne nowe pole nie wychodzi poza biala liste recenzenta.
 *
 * Mowca bez powtorzen nie ma bloku, a gdy nic sie nie powtarza u nikogo, karty nie ma wcale.
 */
export function KartaPowtarzanychSlow({
  mowcy,
  powtarzane,
  onPokaz,
}: {
  mowcy: readonly RecenzjaMowca[];
  powtarzane: PowtarzaneSlowaWgMowcy;
  /** Przewija transkrypt do wypowiedzi o tym numerze (od 1) i zaznacza w niej trafienia slowa. */
  onPokaz: PokazWypowiedzZeSlowem;
}): React.JSX.Element | null {
  const zPowtorzeniami = mowcy
    .map((mowca, indeks) => ({ mowca, indeks, slowa: powtarzane.get(kluczMowcyRecenzji(indeks)) ?? [] }))
    .filter((m) => m.slowa.length > 0);
  if (zPowtorzeniami.length === 0) return null;

  return (
    <Card tytul="Powtarzane słowa">
      <p className="field-hint powtarzane-slowa__lead">{OBJASNIENIE_POWTARZANYCH_SLOW}</p>
      {/* Region bloku ma nazwe z kontekstem ("Powtarzane słowa: Anna"): sama nazwa mowcy w nawigacji po regionach nie
          mowi, czego blok dotyczy. Naglowek h3 zostaje do nawigacji po naglowkach. */}
      {zPowtorzeniami.map(({ mowca, indeks, slowa }) => (
        <section className="powtarzane-slowa" aria-label={`Powtarzane słowa: ${mowca.nazwa}`} key={indeks}>
          <h3 className="powtarzane-slowa__mowca">{mowca.nazwa}</h3>
          <ListaPowtarzanychSlow slowa={slowa} onPokaz={onPokaz} />
        </section>
      ))}
    </Card>
  );
}
